// import './App.css';
// import { Linkedin, Mail } from 'react-feather';

// function Contact() {
//   return (
//     <footer className="App-footer">
      
//       <a
//         href="https://www.linkedin.com/in/arun-kumar-mehta-182175b6/"
//         target="_blank"
//         rel="noopener noreferrer"
//         aria-label="LinkedIn profile"
//         title="LinkedIn"
//       >
//         <Linkedin />
//       </a>

//       <a
//         href="mailto:kumararunmehta@hotmail.com"
//         aria-label="Email"
//         title="Send Email"
//       >
//         <Mail />
//       </a>

//     </footer>
//   );
// }

// export default Contact;
import './App.css';
import { Linkedin, Mail, Twitter } from 'react-feather';
import found from './found.png';


function Contact() {
  return (
    <div
      style={{
        // minHeight: "100vh",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
      }}
    >
<br/>
<br/>
<br/>
      <h2>
      <p >
        Reach out for professional inquiries, collaborations,
        speaking engagements, or general communication.
      </p>
</h2>
      <footer className="App-footer">
        <a
          href="mailto:kumararunmehta@hotmail.com"
          aria-label="Email"
          title="Send Email"
        >
          <Mail />
        </a>

        <a
          href="https://www.linkedin.com/in/arun-kumar-mehta-182175b6/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn profile"
          title="LinkedIn"
        >
          <Linkedin />
        </a>
                <a
          href="https://x.com/athem108"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn profile"
          title="Twitter"
        >
          <Twitter />
        </a>
    <a
  href="https://www.linkedin.com/company/foundation-for-equity-sustainability-and-future-readiness/"
  target="_blank"
  rel="noopener noreferrer"
>
  <img
    className="App"
    alt="Foundation"
    src={found}
  />
</a>
      </footer>
    </div>
  );
}

export default Contact;